module.exports = __webpack_public_path__ + "static/media/SG200.4cbd1361.png";